export default __webpack_public_path__ + "static/media/bg4.e7cd2a0d.png";